export default "__VITE_ASSET__DWXZX1OJ__"